import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getTokens = async (name) => {
  return instance.post(`${API}/token/getInstaPosts`, { token: name });
};
